export function addComment(postName, parent, comment) {
  if (process.env.NODE_ENV === 'development') {
    return {
      success: true,
      resp: 7282525,
    };
  }

  const formData = new FormData();
  formData.append('post_name', postName);
  formData.append('parent', parent);
  formData.append('comment', comment);

  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/add_comment${wpNonceParam}`,
    {
      method: 'POST',
      body: formData,
    }
  )
    .then((res) => res.json())
    .then((res) => {
      if (!res.success) {
        throw Error(res.data.message);
      }

      return res;
    });
}
